import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { setDownloadPayCsvJobInvisible, getDownloadPayCsvJobs } from 'src/reducers/employees/employeePays';
import { Close } from 'jbc-front/components/icons';
import { JobFailed, JobInprogress, JobSuccess } from 'src/components/JobStatus';
import { scrollToTop } from 'src/utils/Utils';
import styles from './DownloadPayCsvJobStatus.scss';

const DownloadJobResult = ({ tasks, status, hideDownloadJobResults }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeePays.components.DownloadPayCsvJobStatus.Salary_data_CSV_creation_completed');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeePays.components.DownloadPayCsvJobStatus.Salary_data_CSV_creation_failed');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress' || status === 'waiting') {
    statusText = t('features.EmployeePays.components.DownloadPayCsvJobStatus.Salary_data_CSV_creation_in_process');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {!isEmpty(tasks) &&
        tasks.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideDownloadJobResults(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>{tasks.map(task => <JobSuccess key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideDownloadJobResults(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>{tasks.map(task => <JobFailed key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
              {(status === 'inProgress' || status === 'waiting') && (
                <React.Fragment>
                  <ul className={styles.list}>{tasks.map(task => <JobInprogress key={task.id} statusText={statusText} {...task} />)}</ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(tasks) && null}
    </React.Fragment>
  );
};

class DownloadPayCsvJobStatus extends React.Component {
  componentDidUpdate(prevProps) {
    const { downloadJobs = {} } = this.props;
    const newFailedJobs = _.get(downloadJobs, 'failed', []);
    const currentFailedJobs = _.get(prevProps, 'downloadJobs.failed', []);
    const hasError = newFailedJobs.length > currentFailedJobs.length;

    if (hasError) {
      scrollToTop();
    }
  }

  render() {
    const { downloadJobs = {}, hideDownloadJobResults } = this.props;
    const sortCondition = (_status1, status2) => {
      if (status2 === 'inProgress' || status2 === 'waiting') return -1; // In progress tasks are on bottom
      if (status2 === 'success') return -1; // Successful tasks are on top
      return 0; // Failed tasks are in middle
    };
    return (
      <React.Fragment>
        {isEmpty(downloadJobs) ? null : (
          <div>
            {Object.keys(downloadJobs)
              .sort(sortCondition)
              .map(status => (
                <DownloadJobResult
                  key={status}
                  tasks={downloadJobs[status]}
                  status={status}
                  hideDownloadJobResults={hideDownloadJobResults}
                />
              ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  downloadJobs: getDownloadPayCsvJobs(state)
});

const mapDispatchToProps = dispatch => ({
  hideDownloadJobResults: tasks => {
    if (isEmpty(tasks)) return;

    const taskIds = tasks.map(j => j.id).join('_');
    dispatch(setDownloadPayCsvJobInvisible(taskIds));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPayCsvJobStatus);
